import React from 'react';
import { Plus, History, Wrench, Settings, ClipboardCheck } from 'lucide-react';
import MaintenanceSummaryCard from './MaintenanceSummaryCard';

const MaintenanceSidebar = ({
  stats,
  upcomingJobs,
  onQuickAction,
  onSyncRequirements,
  hasUpdates,
  checking,
  // FT-267: gate the new "Log Maintenance" affordance on the same
  // maintenance.complete permission used elsewhere for completion actions.
  canLogAdhocMaintenance = false,
}) => {
  return (
    <div className="space-y-6">
      {/* Summary Card */}
      <MaintenanceSummaryCard stats={stats} />

      {/* Quick Actions Card */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
        <div className="bg-slate-700 px-5 py-3">
          <h3 className="text-base font-semibold text-white flex items-center gap-2">
            <Wrench className="h-5 w-5 text-white" />
            Quick Actions
          </h3>
        </div>
        <div className="p-6 space-y-2">
          {/* FT-16: min-h-[44px] ensures 44px+ touch targets on mobile */}
          <button
            onClick={() => onQuickAction('add')}
            className="w-full inline-flex items-center justify-center gap-2 px-4 py-3 md:py-2 text-base md:text-sm font-medium text-white bg-cyan-600 rounded-md hover:bg-cyan-700 min-h-[44px]"
          >
            <Plus className="h-5 w-5 md:h-4 md:w-4" />
            Add Job
          </button>
          {canLogAdhocMaintenance && (
            <button
              onClick={() => onQuickAction('log-adhoc')}
              className="w-full inline-flex items-center justify-center gap-2 px-4 py-3 md:py-2 text-base md:text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 min-h-[44px]"
            >
              <ClipboardCheck className="h-5 w-5 md:h-4 md:w-4" />
              Log Maintenance
            </button>
          )}
          <button
            onClick={() => onQuickAction('history')}
            className="w-full inline-flex items-center justify-center gap-2 px-4 py-3 md:py-2 text-base md:text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 min-h-[44px]"
          >
            <History className="h-5 w-5 md:h-4 md:w-4" />
            History
          </button>
          <button
            onClick={() => onQuickAction('settings')}
            className="w-full inline-flex items-center justify-center gap-2 px-4 py-3 md:py-2 text-base md:text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 min-h-[44px]"
          >
            <Settings className="h-5 w-5 md:h-4 md:w-4" />
            Settings
          </button>
        </div>
      </div>
    </div>
  );
};

export default MaintenanceSidebar;